import { render, staticRenderFns } from "./VacancyAssignRecruiter.vue?vue&type=template&id=58c59843"
import script from "./VacancyAssignRecruiter.vue?vue&type=script&lang=js"
export * from "./VacancyAssignRecruiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports